



















































































































import { Component, Vue, Emit, Prop } from 'vue-property-decorator';
import {
  Project,
  UpdateProjectTaskAttributeValueOptionsParam,
  UpdateProjectCustomAttributesParam,
  UpdateTaskAttributeParam,
  AttributeCd,
} from '@/@types/Project';
import DebugUserIcon from '@/components/common/DebugUserIcon.vue';
import CommonButton from '@/components/common/CommonButton.vue';
import { valueof } from '@/@types/Common';
import { vxm } from '@/store';
import { ATTRIBUTE_DISPLAY_STYLE, ATTRIBUTE_STYLE } from '@/@types/constant';

@Component({
  components: {
    DebugUserIcon,
    CommonButton,
  },
})
export default class CustomAttributeAddModal extends Vue {
  @Prop({ default: 0 })
  private customAttributeIndex!: number;
  private addCommonButtonColor: string = '#4384f3';
  /** タスク追加モーダルの表示状態 */
  private isCustomAttributeAddModal: boolean = true;
  private isActive: boolean = false;
  private customAttributeName: string = '';
  private customAttributeStyle: valueof<keyof typeof ATTRIBUTE_STYLE> | null = null;
  private customAttributeDisplayStyle: valueof<keyof typeof ATTRIBUTE_DISPLAY_STYLE> | null = null;
  private attributeOprionValue = {
    attributeOptionValue1: '',
    attributeOptionValue2: '',
    attributeOptionValue3: '',
    attributeOptionValue4: '',
    attributeOptionValue5: '',
  };
  private colorCd = {
    colorCd1: '',
    colorCd2: '',
    colorCd3: '',
    colorCd4: '',
    colorCd5: '',
  };
  private attributeItemContent = {
    attributeItemContent1: '',
    attributeItemContent2: '',
    attributeItemContent3: '',
    attributeItemContent4: '',
    attributeItemContent5: '',
  };

  /** 必要な表示データ */
  //形式・表示形式・色
  private attributeStyles = ['date', 'person', 'text', 'option', 'number'];

  private attributeDisplayStyles = ['tile', 'belt', 'accent', 'combo', 'radio'];

  private colors = ['aliceblue', 'antiquewhite', 'aqua', 'aquamarine', 'azure'];

  private checkAttributeOption() {
    if (this.customAttributeStyle === ATTRIBUTE_STYLE.OPTION) {
      this.emitTaskAttributeValueOptionsData();
    } else {
      this.emitProjectCustomAttributesData();
    }
  }

  /** カスタム属性が30まで設定されている場合はfalseを返す */
  private isValidCutomAttribute(): boolean {
    return this.customAttributeIndex !== 0;
  }

  private isCheckCustomAttributeStyle(customAttributeStyle: string) {
    if (
      customAttributeStyle === ATTRIBUTE_STYLE.TEXT ||
      customAttributeStyle === ATTRIBUTE_STYLE.OPTION ||
      customAttributeStyle === ATTRIBUTE_STYLE.NUMBER
    ) {
      return true;
    } else {
      return false;
    }
  }

  private isCheckOptionStyle(customAttributeStyle: string) {
    if (customAttributeStyle === ATTRIBUTE_STYLE.OPTION) {
      return true;
    } else {
      return false;
    }
  }

  private get project(): Project | undefined {
    const response = vxm.theoryApi.projectsStore.getProject;
    if (response) {
      return response.results;
    } else undefined;
  }

  @Emit('emitTaskAttributeValueOptionsData')
  private emitTaskAttributeValueOptionsData(): {
    param: UpdateProjectTaskAttributeValueOptionsParam;
    query: valueof<keyof typeof AttributeCd>[];
  } {
    /** プロジェクトのプロパティからカスタム属性名称のみ取得 */
    const keys = Object.keys(this.project as Project).filter((key) => {
      return key.substr(0, 6) === 'custom' && key.substr(-4, 4) === 'Name';
    });
    /** プロジェクトの全カスタム属性名称のうち、値がnullである最初のプロパティ名から数字のみを取得 */
    const attributeIndex = this.customAttributeIndex;
    const attributeCd: valueof<keyof typeof AttributeCd>[] = [`attribute${attributeIndex}`];
    /** プロジェクトカスタム属性のパラメータを生成 */
    let updateProjectTaskAttributeValueOptionParam: UpdateProjectTaskAttributeValueOptionsParam = {
      projectCustomAttribute: {},
      taskAttributes: [],
    };
    updateProjectTaskAttributeValueOptionParam.projectCustomAttribute[`customAttribute${attributeIndex}Name`] = this.customAttributeName;
    updateProjectTaskAttributeValueOptionParam.projectCustomAttribute[`customAttribute${attributeIndex}Style`] = this.customAttributeStyle;
    updateProjectTaskAttributeValueOptionParam.projectCustomAttribute[`customAttribute${attributeIndex}DisplayStyle`] = this.customAttributeDisplayStyle;
    updateProjectTaskAttributeValueOptionParam.projectCustomAttribute[`customAttribute${attributeIndex}DisplayFlag`] = true;
    for (let i = 1; i <= 5; i++) {
      const attribute = {
        attributeCd: `attribute${attributeIndex}`,
        value: this.attributeOprionValue[`attributeOptionValue${i}`],
        colorCd: this.colorCd[`colorCd${i}`],
        attributeItemContent: this.attributeItemContent[`attributeItemContent${i}`],
      };
      /** 色CDが未入力の場合は送信しない */
      if (attribute.colorCd.length > 0) {
        updateProjectTaskAttributeValueOptionParam.taskAttributes.push(attribute as UpdateTaskAttributeParam);
      }
    }
    this.isCustomAttributeAddModal = false;
    return {
      param: updateProjectTaskAttributeValueOptionParam,
      query: attributeCd,
    };
  }

  @Emit('emitProjectCustomAttributesData')
  private emitProjectCustomAttributesData(): UpdateProjectCustomAttributesParam {
    /** プロジェクトのプロパティからカスタム属性名称のみ取得 */
    const keys = Object.keys(this.project).filter((key) => {
      return key.substr(0, 6) === 'custom' && key.substr(-4, 4) === 'Name';
    });
    /** プロジェクトの全カスタム属性名称のうち、値がnullである最初のプロパティ名から数字のみを取得 */
    const attributeIndex =
      keys.findIndex((key, index) => {
        return this.project[`customAttribute${index + 1}Name`] == null;
      }) + 1;
    /** プロジェクトカスタム属性のパラメータを生成 */
    let updateProjectCustomAttributesParam: UpdateProjectCustomAttributesParam = {};
    updateProjectCustomAttributesParam[`customAttribute${attributeIndex}Name`] = this.customAttributeName;
    updateProjectCustomAttributesParam[`customAttribute${attributeIndex}Style`] = this.customAttributeStyle;
    updateProjectCustomAttributesParam[`customAttribute${attributeIndex}DisplayStyle`] =this.customAttributeDisplayStyle;
    updateProjectCustomAttributesParam[`customAttribute${attributeIndex}DisplayFlag`] = true;
    this.isCustomAttributeAddModal = false;
    return updateProjectCustomAttributesParam;
  }

  @Emit('close')
  private close(): void {
    this.isCustomAttributeAddModal = false;
  }
}
